const PLANNER_BOARD_SCALE_CAP = 0.46;
const PLANNER_BOARD_STAGE_PADDING = 24;

export function computePlannerBoardFitScale(stageWidth, boardLength) {
  const width = stageWidth || 820;
  return Math.min((width - PLANNER_BOARD_STAGE_PADDING) / boardLength, PLANNER_BOARD_SCALE_CAP);
}
